module.exports = __webpack_public_path__ + "media/images/country_flags/np-22e576cb53de6550ed8573658658b0bb.png";